//@flow

import React from "react"

import { ForecastMetricContainer } from "../UI"

import ForecastMetricTitleGroup from "./ForecastMetricTitleGroup"
import ForecastProgress from "./ForecastProgress"
import MetricStatus from "./MetricStatus"

import type { Direction } from "../types"
import type { Level, Metric } from "../../Shared/AQILegend"

const ForecastMetric = ({
  level,
  direction,
  pollutant,
  delay,
  readings,
  onClick,
  innerRef
}: {
  level: Level,
  direction: Direction,
  pollutant: Metric,
  delay?: number,
  readings: number[],
  onClick: (metric: Metric) => any,
  innerRef?: (el: HTMLElement) => any
}) => (
  <ForecastMetricContainer
    innerRef={innerRef}
    onClick={() => onClick(pollutant)}
  >
    <ForecastProgress
      level={level}
      direction={direction}
      pollutant={pollutant}
      readings={readings}
      delay={delay || 0}
    />
    <ForecastMetricTitleGroup pollutant={pollutant} />
    <MetricStatus level={level} direction={direction} />
  </ForecastMetricContainer>
)

export default ForecastMetric



// WEBPACK FOOTER //
// ./src/Kiosk/CurrentAirQualityView/ForecastMetric/ForecastMetric.js